import { AxiosRequestConfig } from 'axios'

export interface ActiveUsersEvolutionByLevelParams {
  endDate: string
  storeId?: number
  userType?: 'all' | 'recurrent'
}

export interface ActiveUsersEvolutionByLevelData {
  month: string
  [key: string]: string | number // Dynamic level properties
}

export interface ActiveUsersEvolutionByLevelResponse {
  data: {
    dates: ActiveUsersEvolutionByLevelData[]
    levels: Array<{
      name: string
      level: number
    }>
  }
}

export const getActiveUsersEvolutionByLevel = (
  params: ActiveUsersEvolutionByLevelParams,
): AxiosRequestConfig => ({
  url: '/dashboard/active-users-evolution-by-level',
  method: 'GET',
  params,
})
